export default "__VITE_ASSET__B1vfTKT5__"